import React, { useState } from 'react'
import { Form, Table } from 'react-bootstrap'
import '../../../index.css'
import { FetchCreateTransaction, FetchCreateTransactionDraft, FetchUpdateTransactionDraft } from '../../../fetcher'
import AlertMessage from '../../alertmessages/AlertMessageView'
import { ModalView } from '../../_reusedcomponents/ModalView'
import { TransactionOrderView } from './TransactionOrderView'

const MaintainStockListView = ({ removeOrderEntry, addToStock, lowerStock = false, remark, resetOrderEntries, handleCloseMask, reloadParent, isDraftUpdate = false, draftSysId = null }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const OpenModal = () => {
        return (
            handleShow()
        )
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [hasInvalidArticles, setHasInvalidArticles] = useState(false)

    const submitStock = () => {
        const transactionToCreate = {
            TransactionType: lowerStock ? "CorrectionForNewArrivals" : "NewArrivals",
            SerializedArticleData: JSON.stringify(addToStock),
            Remark: remark,
            CreateTransactionFromDraft: isDraftUpdate,
            ToLowerStock: lowerStock
        };
        isDraftUpdate ? /*-- do create Transaction from draft here --*/ FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries)
            : FetchCreateTransaction(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries)

        //resetOrderEntries()
        handleClose()
    }

    const saveStock = () => {
        const transactionToCreate = {
            TransactionType: lowerStock ? "CorrectionForNewArrivals" : "NewArrivals",
            SerializedArticleData: JSON.stringify(addToStock),
            Remark: remark,
            CreateTransactionFromDraft: false,
            ToLowerStock: lowerStock
        };
        isDraftUpdate ? FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries)
            : FetchCreateTransactionDraft(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries)

        //resetOrderEntries()
        handleClose()
    }

    return (
        <div className="listtable table-width">
            <Form onSubmit={e => {
                e.preventDefault()
                OpenModal()
            }} id="maintain-stock-submit">
                <Table striped hover aria-labelledby="tabelLabel" size="sm">
                    {addToStock.map(entry =>
                        <TransactionOrderView removeOrderEntry={removeOrderEntry} {...entry} isDeliveryOrder={false} setHasInvalidArticles={setHasInvalidArticles} />
                    )}
                </Table>

                {/*{addToStock != null && addToStock.length != 0 && <Button variant="secondary" type="submit">Bestand Aktualisieren</Button>}*/}
            </Form>

            <ModalView handleShow={show} handleClose={handleClose} handleSubmit={submitStock} isDraftModal={true} handleSave={saveStock}
                modalTitle={window.i18n('updateStock')}
                modalBody={window.i18n('updateStock2')} />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}
export { MaintainStockListView }